var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 275,
    height: 137,
    viewBox: "0 0 275 137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_8",
    x: 0,
    y: 0,
    width: 275,
    height: 137,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(-51 -241)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 51, 241)",
    filter: "url(#Rectangle_8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8-2",
    "data-name": "Rectangle 8",
    width: 257,
    height: 119,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(-938.239 -354.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(-19 20.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(0 19)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "t_l",
    "data-name": "t     l",
    transform: "translate(1195 657)",
    fill: "#8c776b",
    fontSize: 27,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "t     l")), /*#__PURE__*/React.createElement("text", {
    id: "Marketing",
    transform: "translate(1107 624)",
    fill: "#8c776b",
    fontSize: 27,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Marketing")), /*#__PURE__*/React.createElement("g", {
    id: "noun-connectivity-223831",
    transform: "translate(1202.622 635.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M6.5,17.142a2.351,2.351,0,0,1,.448-1.382,7.441,7.441,0,0,1-.28-2.036,7.886,7.886,0,0,1,2.317-5.6,8.438,8.438,0,0,1,2.13-1.532,3.628,3.628,0,0,0-.037.448,3.541,3.541,0,0,0,.654,2.055,5.448,5.448,0,0,0-2.559,4.633,5.381,5.381,0,0,0,.112,1.1A2.372,2.372,0,1,1,6.5,17.142Zm3.755,3.213a7.927,7.927,0,0,0,9.808-.859,2.031,2.031,0,0,0,.336.019,2.373,2.373,0,1,0-2.373-2.373,2.258,2.258,0,0,0,.112.71,5.478,5.478,0,0,1-3.531,1.308,5.337,5.337,0,0,1-2.541-.635A3.539,3.539,0,0,1,10.255,20.355ZM14.608,9.408A2.392,2.392,0,0,0,16.4,8.586a5.418,5.418,0,0,1,3.643,5.081,2.031,2.031,0,0,1,.336-.019,3.416,3.416,0,0,1,2.13.729c.019-.205.019-.43.019-.635a7.886,7.886,0,0,0-2.317-5.6A7.777,7.777,0,0,0,16.775,6.12a2.364,2.364,0,1,0-2.167,3.288Z",
    transform: "translate(0 0)",
    fill: "#867166"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-connectivity-223831-2",
    "data-name": "noun-connectivity-223831",
    transform: "translate(1221.622 635.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23-2",
    "data-name": "Path 23",
    d: "M6.5,17.142a2.351,2.351,0,0,1,.448-1.382,7.441,7.441,0,0,1-.28-2.036,7.886,7.886,0,0,1,2.317-5.6,8.438,8.438,0,0,1,2.13-1.532,3.628,3.628,0,0,0-.037.448,3.541,3.541,0,0,0,.654,2.055,5.448,5.448,0,0,0-2.559,4.633,5.381,5.381,0,0,0,.112,1.1A2.372,2.372,0,1,1,6.5,17.142Zm3.755,3.213a7.927,7.927,0,0,0,9.808-.859,2.031,2.031,0,0,0,.336.019,2.373,2.373,0,1,0-2.373-2.373,2.258,2.258,0,0,0,.112.71,5.478,5.478,0,0,1-3.531,1.308,5.337,5.337,0,0,1-2.541-.635A3.539,3.539,0,0,1,10.255,20.355ZM14.608,9.408A2.392,2.392,0,0,0,16.4,8.586a5.418,5.418,0,0,1,3.643,5.081,2.031,2.031,0,0,1,.336-.019,3.416,3.416,0,0,1,2.13.729c.019-.205.019-.43.019-.635a7.886,7.886,0,0,0-2.317-5.6A7.777,7.777,0,0,0,16.775,6.12a2.364,2.364,0,1,0-2.167,3.288Z",
    transform: "translate(0 0)",
    fill: "#867166"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "noun-connectivity-223831-3",
    "data-name": "noun-connectivity-223831",
    transform: "translate(1031.739 593.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23-3",
    "data-name": "Path 23",
    d: "M6.5,53.11a9.147,9.147,0,0,1,1.744-5.379,28.953,28.953,0,0,1-1.09-7.923A30.682,30.682,0,0,1,16.167,18a32.83,32.83,0,0,1,8.286-5.96,14.115,14.115,0,0,0-.145,1.744,13.777,13.777,0,0,0,2.544,8,21.2,21.2,0,0,0-9.958,18.026A20.937,20.937,0,0,0,17.33,44.1,9.229,9.229,0,1,1,6.5,53.11Zm14.61,12.5a30.844,30.844,0,0,0,38.161-3.344,7.9,7.9,0,0,0,1.308.073,9.231,9.231,0,1,0-9.231-9.231,8.787,8.787,0,0,0,.436,2.762A21.312,21.312,0,0,1,38.046,60.96a20.764,20.764,0,0,1-9.885-2.471A13.769,13.769,0,0,1,21.11,65.612ZM38.046,23.017a9.308,9.308,0,0,0,6.978-3.2A21.079,21.079,0,0,1,59.2,39.59a7.9,7.9,0,0,1,1.308-.073,13.293,13.293,0,0,1,8.286,2.835c.073-.8.073-1.672.073-2.471a30.682,30.682,0,0,0-9.013-21.806,30.26,30.26,0,0,0-13.374-7.85,9.2,9.2,0,1,0-8.432,12.793Z",
    fill: "#67574f"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrm);
export default __webpack_public_path__ + "static/media/crm.55863a93158f6140fdac56287c46be98.svg";
export { ForwardRef as ReactComponent };